import { render, staticRenderFns } from "./_Message.vue?vue&type=template&id=cd6163c6&"
import script from "./_Message.vue?vue&type=script&lang=js&"
export * from "./_Message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports